import React, { useRef, useEffect, forwardRef } from 'react';
import { composeRef } from 'rc-util/lib/ref';
import raf from 'rc-util/lib/raf';
import Tooltip from '../tooltip';
const SliderTooltip = forwardRef((props, ref) => {
    const { visible } = props;
    const innerRef = useRef(null);
    const rafRef = useRef(null);
    const cancelKeepAlign = () => {
        raf.cancel(rafRef.current);
        rafRef.current = null;
    };
    const keepAlign = () => {
        rafRef.current = raf(() => {
            var _a;
            (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.forcePopupAlign();
            rafRef.current = null;
        });
    };
    useEffect(() => {
        if (visible) {
            keepAlign();
        }
        else {
            cancelKeepAlign();
        }
        return cancelKeepAlign;
    }, [visible, props.title]);
    return <Tooltip ref={composeRef(innerRef, ref)} {...props}/>;
});
export default SliderTooltip;
